import React, { useState, useEffect } from 'react';
import './PokeApi.css';
import './PokeCharacter.css';
import { Link } from 'react-router-dom';



const PokeApi = (props) => {
    const [names,setNames] = useState([]);
    const [pokemonList, setPokemonList] = useState([]);

    useEffect(() => {
        const pokemons = [...props.element];
        const pokemonsNames = [];
        const pokemonListBuffer = [];
        for (let i = 0; i < 3; i++) {
            const pok = Math.floor(Math.random() * pokemons.length);
            pokemonsNames.push(pokemons[pok].name);
            pokemonListBuffer.push(pokemons[pok]);
            pokemons.splice(pok, 1);
        }
        setPokemonList(pokemonListBuffer);
        setNames(pokemonsNames);
    }, [props.element])


    return (
        
        <div className="pokemonsByElements">
            { pokemonList.length &&
			<Link to="/characteristics-page" className="link" onClick={() => props.choosePokemon(pokemonList[0])}> 
                <div className='Search'>
                    {names.length ?
                    <div>
                        <img src={`http://www.pokestadium.com/sprites/xy/${names[0]}.gif`} alt="pokemon picture"/>
                        <h1 style={{fontFamily: "DisposableDroidBB"}}>{names[0]}</h1>
                    </div>
                    : 
                    <p>not found!!</p>}
                </div>
            </Link>} 
            { pokemonList.length &&
            <Link to="/characteristics-page" className="link" onClick={() => props.choosePokemon(pokemonList[1])}>
                <div className='Search'>
                    {names.length ?
                    <div>
                        <img src={`http://www.pokestadium.com/sprites/xy/${names[1]}.gif`} alt="pokemon picture"/>
                        <h1 style={{fontFamily: "DisposableDroidBB"}}>{names[1]}</h1>
                    </div>
                    : 
                    <p>not found!!</p>}
                </div>
            </Link>  }    
            { pokemonList.length &&     
            <Link to="/characteristics-page" className="link" onClick={() => props.choosePokemon(pokemonList[2])}>
                <div className='Search'>
                    {names.length ?
                    <div>
                        <img src={`http://www.pokestadium.com/sprites/xy/${names[2]}.gif`} alt="pokemon picture"/>
                        <h1 style={{fontFamily: "DisposableDroidBB"}}>{names[2]}</h1>
                    </div>
                    : 
                    <p>not found!!</p>}
                </div>
            </Link>
            }
        </div>
    );
};

export default PokeApi;